import React, { useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { FormTodo, FormTodoType } from "./FormTodo.tsx";

interface PasswordInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    formTodos?: Array<FormTodoType>;
    fieldName?: string;
}

export function PasswordInput({ formTodos, fieldName, className = "", ...props }: PasswordInputProps) {
    const [showPassword, setShowPassword] = useState(false);

    const baseClassName = "px-2 block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6";
    const finalClassName = `${baseClassName} ${className}`.trim();

    return (
        <>
            <div className="relative">
                <input
                    {...props}
                    type={showPassword ? "text" : "password"}
                    className={finalClassName}
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <div className="pointer-events-auto">
                        {showPassword ? (
                            <EyeSlashIcon
                                className="h-5 w-5 text-gray-400 cursor-pointer"
                                onClick={() => setShowPassword(false)}
                            />
                        ) : (
                            <EyeIcon
                                className="h-5 w-5 text-gray-400 cursor-pointer"
                                onClick={() => setShowPassword(true)}
                            />
                        )}
                    </div>
                </div>
            </div>
            {formTodos && fieldName && <FormTodo fieldName={fieldName} formTodos={formTodos} />}
        </>
    );
}

